module.exports = __webpack_public_path__ + "c77b33338106305a87de9d8a696bc63a.png";